
import React from 'react';
import ReactToPrint from '../../../../Shared/print/ReactToPrint';
import { IconButton } from '@mui/material';

function PosShiftPrint({ contentRef }) {
  return (
    <div className="justify-center" style={{ gap: "10px", width: "70%", justifyContent: "flex-end" }}>
      <ReactToPrint className="print-btnn"
        trigger={() => (
          <IconButton className="printer-div" style={{ color: "#fff", backgroundColor: "#002995", borderRadius: "0" }}>
            <i className="bi bi-printer"></i>
          </IconButton>
        )}
        content={() => contentRef.current}  // Pass the content reference to print
      />
    </div>
  );
}

export default PosShiftPrint;
